<script>
    import { onDestroy, onMount } from 'svelte';

    let loadingText = "Fetching your data"
    let counter = 0
    let dots = "."

    const interval = setInterval(() => {
        counter += 1
      }, 1000);

    let updateProgressText = (counter) => {
        if(counter%10 == 0) dots = "."
        else dots = dots+" ."

        if(counter < 3){
            loadingText = "Fetching your data"
        }
        else if(counter < 6){
            loadingText = "Analyzing data"
        }
        else if(counter < 9){
            loadingText = "Calculating Your Marks"
        }
        else if(counter < 12) {
            loadingText = "Calculating Result"
        }
        else if(counter < 25){
            loadingText = "Calculating Result, please wait"
        }
    }

    $: counter, updateProgressText(counter);

    onDestroy(()=>{
        clearInterval(interval)
    })

    onMount(async () => {
        if(!value || value=="undefined" || value=="null"){
            value="";
        }
    })  
</script>
<div class="loading-progress-container">
    <div class="loader-2-container"><div class="loadingprogress"></div></div>
    <span>{loadingText}</span>
    <h4>{dots}</h4>
</div>

